module.exports = __webpack_public_path__ + "img/gift-bg.8f02bf93.jpg";